import { Component, OnInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { AuthService } from '../services/auth.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms'; // Necesario para [(ngModel)]

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule], // Importamos FormsModule para ngModel
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  // Variable para verificar si el usuario está autenticado
  isAuthenticated = false;
  isMobile = false;

  // Datos de ejemplo para los episodios y las obras
  episodes = [
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '1.9k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.1k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.3k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '1.9k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.1k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.3k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '1.9k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.1k' },
    { img: 'https://m.media-amazon.com/images/I/91jahq5PI2L._AC_UF894,1000_QL80_.jpg', title: 'Specimens The Origi...', author: 'Oshita Kami', views: '2.3k' },
    // Más episodios aquí
  ];

  artworks = [
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '181' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '182' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '183' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '181' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '182' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '183' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '181' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '182' },
    { img: 'https://i0.wp.com/lacovacha.mx/wp-content/uploads/2021/10/0.manga-vs-comic-0.jpg', title: 'American Dark Age', author: 'Jisatsu', views: '183' },
    // Más obras aquí
  ];

  sidebarItems = [
    { img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Figure_in_Manga_style.png/800px-Figure_in_Manga_style.png', title: 'American Dark Age', author: 'Jisatsu', views: '181' },
    { img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Figure_in_Manga_style.png/800px-Figure_in_Manga_style.png', title: 'The Last Requiem', author: 'Kaiten', views: '220' },
    { img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Figure_in_Manga_style.png/800px-Figure_in_Manga_style.png', title: 'Rise of the Phoenix', author: 'Nayuma', views: '150' },
    // Más elementos aquí
  ];

  constructor(
    public translationService: TranslationService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    // Suscribirse al estado de autenticación
    this.authService.userRole$.subscribe(role => {
      this.isAuthenticated = !!role; // Si el usuario tiene un rol, está autenticado
    });

    // Manejar cambio de idioma (si es necesario)
    this.translationService.currentLanguage$.subscribe((lang) => {
      // Lógica para cambios de idioma
    });

    if (isPlatformBrowser(this.platformId)) {
      this.checkViewport();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkViewport();
    }
  }

  checkViewport() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 768; // Adjust the width as needed
    }
  }

  // Lógica para mover el carrusel (mover una tarjeta a la vez)
  nextCarousel(carouselId: string) {
    const container = document.getElementById(carouselId);
    if (container) {
      const cardWidth = container.querySelector('.carousel-item')?.clientWidth || 0; // Ancho de una tarjeta
      container.scrollLeft += cardWidth; // Desplazar una tarjeta
    }
  }

  prevCarousel(carouselId: string) {
    const container = document.getElementById(carouselId);
    if (container) {
      const cardWidth = container.querySelector('.carousel-item')?.clientWidth || 0;
      container.scrollLeft -= cardWidth; // Desplazar una tarjeta
    }
  }

  discoverRandomStory() {
    const randomIndex = Math.floor(Math.random() * this.episodes.length);
    const randomEpisode = this.episodes[randomIndex];
    alert(`Descubre: ${randomEpisode.title} por ${randomEpisode.author}`);
  }
}
